import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import { loadReduxState } from './_helpers/localStorageHelper'
import theme from './theme'
import frLocale from 'date-fns/locale/fr'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { BrowserRouter } from 'react-router-dom'
import './firebase'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './store/reducers/rootReducer'
import './i18n'


const store = configureStore({ reducer: rootReducer, preloadedState: loadReduxState() })

const container = document.getElementById('app')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
